import React from 'react';

const Time = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 24.794C8.048 24.794 3.206 19.952 3.206 14 3.206 8.048 8.048 3.206 14 3.206c5.952 0 10.794 4.842 10.794 10.794 0 5.952-4.842 10.794-10.794 10.794m0-22.588c6.503 0 11.794 5.29 11.794 11.794 0 6.503-5.291 11.794-11.794 11.794S2.206 20.503 2.206 14 7.497 2.206 14 2.206zM19.082 13.5H14.5l.014-7.405a.5.5 0 1 0-1-.002l-.014 7.906a.504.504 0 0 0 .5.501h5.082a.5.5 0 0 0 0-1z"
    />
  </svg>
);

export default Time;
